export enum AvailabilityStatus {
  AvailableWithSchedule = 'availableWithSchedule',
  AvailableOrConditional = 'availableOrConditional',
}
